/**
 * PageLoader Component
 * Full page loading indicator
 */

import React from 'react';
import { CustomSpin } from '../CustomSpin';
import './PageLoader.scss';

interface PageLoaderProps {
  tip?: string;
  size?: 'small' | 'default' | 'large';
}

/**
 * PageLoader Component - Full page loading indicator
 * @param tip - Loading message to display
 * @param size - Spinner size (small, default, large)
 * @returns Page loader component
 */
const PageLoader: React.FC<PageLoaderProps> = ({ tip = 'Loading...', size = 'large' }) => {
  return (
    <div className="page-loader">
      <div className="page-loader__content">
        <CustomSpin size={size} tip={tip} />
      </div>
    </div>
  );
};

export default PageLoader;
